import { render, staticRenderFns } from "./CpttEditAppr.vue?vue&type=template&id=cc465956&scoped=true&"
import script from "./CpttEditAppr.vue?vue&type=script&lang=js&"
export * from "./CpttEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc465956",
  null
  
)

export default component.exports